import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useEffect, useState } from 'react';
var state = {
  whenOnline: 'online',
  whenOffline: 'offline'
};

function useNavigatorOnline() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : state,
      whenOnline = _ref.whenOnline,
      whenOffline = _ref.whenOffline;

  var _useState = useState(window.navigator.onLine),
      _useState2 = _slicedToArray(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1];

  useEffect(function () {
    function handleOnlineStatus() {
      setValue(window.navigator.onLine);
    }

    window.addEventListener('online', handleOnlineStatus);
    window.addEventListener('offline', handleOnlineStatus);
    return function () {
      window.removeEventListener('online', handleOnlineStatus);
      window.removeEventListener('offline', handleOnlineStatus);
    };
  }, []);
  var isOnline = value === true;
  var isOffline = value === false;
  var status = isOnline ? whenOnline : whenOffline;
  return {
    status: status,
    isOnline: isOnline,
    isOffline: isOffline
  };
}

export default useNavigatorOnline;